import { FlexBox } from "@brg/ui";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import styled from "styled-components";

interface CheckLongreadRadioButtonProps {
  onChange: () => void;
  name: string;
  title: string;
  checked: boolean;
  hintText?: string
}

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 16px;
  color: #909090;
`;

const HiddenRadio = styled.input`
  display: none;
`;

const CustomRadio = styled.div<{ checked: boolean }>`
  width: 20px;
  height: 20px;
  border: 2px solid #909090;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: ${({ checked }) => (checked ? "#151514" : "transparent")};
    border-radius: 50%;
  }
`;

const TitleWrapper = styled(FlexBox)`
  .info-icon-wrapper {
    margin-left: 8px;
    width: 12px;
    height: 12px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

const CheckLongreadRadioButton: React.FC<CheckLongreadRadioButtonProps> = ({
  onChange,
  name,
  title,
  checked,
  hintText
}) => {
  return (
    <RadioLabel className="radio-button--label">
      <HiddenRadio type="radio" name={name} onChange={onChange} checked={checked} />
      <CustomRadio className="radio-button--custom-radio" checked={checked} />
      <TitleWrapper gx={8} gxMobile={8} align={'center'}>
        {title}
        {hintText && <InfoIcon stc msg={hintText} />}
      </TitleWrapper>
    </RadioLabel>
  );
};

export default CheckLongreadRadioButton;import { FlexBox } from "@brg/ui";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import styled from "styled-components";

interface CheckLongreadRadioButtonProps {
  onChange: () => void;
  name: string;
  title: string;
  checked: boolean;
  hintText?: string
}

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 16px;
  color: #909090;
`;

const HiddenRadio = styled.input`
  display: none;
`;

const CustomRadio = styled.div<{ checked: boolean }>`
  width: 20px;
  height: 20px;
  border: 2px solid #909090;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: ${({ checked }) => (checked ? "#151514" : "transparent")};
    border-radius: 50%;
  }
`;

const TitleWrapper = styled(FlexBox)`
  .info-icon-wrapper {
    margin-left: 8px;
    width: 12px;
    height: 12px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

const CheckLongreadRadioButton: React.FC<CheckLongreadRadioButtonProps> = ({
  onChange,
  name,
  title,
  checked,
  hintText
}) => {
  return (
    <RadioLabel className="radio-button--label">
      <HiddenRadio type="radio" name={name} onChange={onChange} checked={checked} />
      <CustomRadio className="radio-button--custom-radio" checked={checked} />
      <TitleWrapper gx={8} gxMobile={8} align={'center'}>
        {title}
        {hintText && <InfoIcon stc msg={hintText} />}
      </TitleWrapper>
    </RadioLabel>
  );
};

export default CheckLongreadRadioButton;